export interface Vec2 {
    x: number
    y: number
}

export interface Particle {
    position: Vec2
    previousPosition: Vec2
    acceleration: Vec2
    mass: number
    pinned: boolean
    radius: number
}

export interface DistanceConstraint {
    indexA: number
    indexB: number
    restLength: number
    stiffness: number
}

export interface ChainConfig {
    beadCount: number
    beadRadius: number
    handleRadius: number
    segmentLength: number
    gravity: number
    damping: number
    constraintIterations: number
    pullThreshold: number
    pullResistanceCurve: number
}

export type ThemeMode = 'light' | 'dark'

export const DEFAULT_CHAIN_CONFIG: ChainConfig = {
    beadCount: 15,
    beadRadius: 4,
    handleRadius: 10,
    segmentLength: 14,
    gravity: 980,
    damping: 0.98,
    constraintIterations: 5,
    pullThreshold: 80,
    pullResistanceCurve: 2.0,
}
